import { useState } from 'react';
import { R } from '@/features/profile/resources/ProfileResources.resx';
import { useAtom, useSetAtom } from 'jotai';
import { Utils } from '@/shared/Utils';
import { useHydrateAtoms } from 'jotai/utils';
import { ISelfResponse } from '@/shared/interfaces';
import { EditIcon } from '@/components/Icons';
import { HorizontalContainer } from '@/components';
import {
    selfRequestAtom,
    selfResponseAtom,
} from '@/features/profile/widgets/my-information/model/myInfoAtoms';
import { MyInfoModal } from '@/features/profile/widgets/my-information/ui';

type MyInfoProps = {
    bootstrappedSelf: ISelfResponse;
};

export const MyInformationApp = ({ bootstrappedSelf }: MyInfoProps) => {
    useHydrateAtoms([[selfResponseAtom, bootstrappedSelf]]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [self] = useAtom(selfRequestAtom);
    const setSelfResponseAtom = useSetAtom(selfResponseAtom);

    if (!self) return;

    return (
        <>
            <HorizontalContainer spacing="sm" className="flex-wrap">
                <h2 id="heading-MyInformation">{R.MyInformation}</h2>
                <div className="max-w-prose">{R.Profile_Description}</div>

                <div className="shrink grow basis-64">
                    <label className="text-text-secondary mb-1 text-sm leading-tight font-normal">
                        {R.Name}
                    </label>
                    <div className="text-text-primary mb-2 text-lg leading-normal font-bold break-all">
                        {self.Name}
                    </div>
                    <label className="text-text-secondary mb-1 text-sm leading-tight font-normal">
                        {R.CprNumber}
                    </label>
                    <div className="text-text-primary text-lg leading-normal font-bold">
                        {Utils.formatCpr(self.CPR)}
                    </div>
                </div>

                <button
                    aria-label={R.EditMyInformationLabelA11y}
                    className="border-border-muted hover:bg-bg-subtle relative shrink grow basis-64 cursor-pointer rounded-2xl border p-4 text-left"
                    onClick={() => setIsModalOpen(true)}
                >
                    <label className="text-text-secondary pointer-events-none mb-1 text-sm leading-tight font-normal">
                        {R.Email}
                    </label>
                    <div className="text-text-primary mb-2 text-lg leading-normal font-bold break-all">
                        {self.Email}
                    </div>
                    <label className="text-text-secondary pointer-events-none mb-1 text-sm leading-tight font-normal">
                        {R.Phone}
                    </label>
                    <div className="text-text-primary text-lg leading-normal font-bold">
                        {self.Mobile}
                    </div>

                    <EditIcon
                        variant="default"
                        className="absolute top-4 right-4"
                        width={24}
                        height={24}
                        aria-hidden="true"
                    />
                </button>
            </HorizontalContainer>

            {isModalOpen && (
                <MyInfoModal
                    selfOnOpen={self}
                    onClose={(selfResponse) => {
                        if (selfResponse) setSelfResponseAtom(selfResponse);
                        setIsModalOpen(false);
                    }}
                ></MyInfoModal>
            )}
        </>
    );
};
